import { render, staticRenderFns } from "./InventoryHome.vue?vue&type=template&id=30aee36e&"
import script from "./InventoryHome.vue?vue&type=script&lang=js&"
export * from "./InventoryHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports